const VERSION = '2.0.15b'
export default VERSION
